import {
  ARCHIVED,
  FAVORITES_PAGE,
  MY_VIDEOS_PAGE,
  SHARED_VIDEOS_PAGE,
  TEAM_VIDEOS_PAGE,
} from './routes';
import { HEX_32_REGEX } from '../../../shared/validate';

export const MY_VIDEOS_PATH_REGEX = new RegExp(`^${MY_VIDEOS_PAGE}`);
export const TEAM_VIDEOS_PATH_REGEX = new RegExp(`^${TEAM_VIDEOS_PAGE}`);
export const SHARED_VIDEOS_PATH_REGEX = new RegExp(`^${SHARED_VIDEOS_PAGE}`);
export const ARCHIVED_PATH_REGEX = new RegExp(`^${ARCHIVED}`);
export const FAVORITES_PATH_REGEX = new RegExp(`^${FAVORITES_PAGE}`);
export const VALIDATE_WORKSPACE_NAME_REGEX = /^[^.:@\/\\]*$/;

export const ID_REGEX = new RegExp(`${HEX_32_REGEX}$`);
export const HTTPS_REGEX = /https:\/\//gi;

// remove the internal regex state between runs (must be done in order to declare in central file)
export const resetRegex = regexes => {
  regexes.forEach(r => (r.lastIndex = 0));
};
